import {
  required as requiredValidator,
  textAreaValidator,
} from "~/core/validators/validators";

export function getRequiredTextFieldLogic() {
  const requiredText = ref("");
  const requiredTextField = ref<any>(null);
  function resetRequiredTextValidation() {
    requiredTextField.value.resetValidation();
  }

  return {
    requiredText,
    requiredTextField,
    resetRequiredTextValidation,
    requiredValidator,
  };
}
